/* Valrella — below-the-fold product detail.
   Everything here comes from the product's own copy or from store policy.
   No invented specifications, ratings or testimonials. */
(function () {
  if (window.__lumenPdpDetail) return;
  window.__lumenPdpDetail = true;

  var SHIPPING =
    "Standard shipping is $6.95 to the UK, United States, Australia, and Canada. We pack in 1–2 business days; delivery is usually 10–25 days after that.";
  var RETURNS =
    "14-day money-back on unused items. Email valrellasupport@gmail.com with your order number — we don't publish a street address. Full terms are in our refund policy.";
  var PACKAGING =
    "Orders arrive safely wrapped in protective packaging so your tool reaches you intact.";
  var NOT_MEDICAL =
    "Valrella tools are beauty accessories for at-home routines. They are not medical devices, and we don't make medical claims. Skip broken or irritated skin and stop if anything feels uncomfortable.";
  var CONTACT =
    "Email valrellasupport@gmail.com. A person reads it. We don't share a street address.";

  var CONTENT = {
    "tool-led": {
      why:
        "A wireless LED face mask built for a proper at-home session — seven colour modes, USB-C charging, and hands-free wear so you can sit back through a full cycle instead of holding a device up.",
      features: [
        "Seven colour modes",
        "Wireless in use — no cord to work around",
        "USB-C rechargeable",
        "Hands-free full-face design",
        "Timing guide included"
      ],
      howTo: [
        "Cleanse and fully dry your skin — no product underneath.",
        "Put the mask on, choose a colour mode and relax for the time in the guide.",
        "Take it off, then carry on with your serum and moisturiser."
      ],
      included: ["LED Mini Face Mask", "Timing guide"],
      specs: [
        ["Type", "Wireless LED face mask"],
        ["Colour modes", "7"],
        ["Charging", "USB-C rechargeable"],
        ["Materials", "LED modules, flexible housing, electronics"]
      ],
      care:
        "Wipe the inside of the mask with a soft, barely damp cloth and let it dry fully before storing. Keep the charging port dry and don't rinse the device under water.",
      faq: [
        [
          "How does it charge?",
          "The LED Mini Face Mask is USB-C rechargeable and runs wirelessly once charged."
        ],
        [
          "What is included?",
          "The mask and a timing guide. No formula is included."
        ],
        [
          "How do I choose a colour mode?",
          "Put the mask on and select a mode on the device. Follow the timing guide for session length."
        ]
      ]
    },
    "tool-gua": {
      why:
        "The classic gua sha motion with gentle warmth and vibration behind it. Heat and vibration add an extra dimension to your facial massage routine — five to ten minutes along the jaw and neck that becomes the part of the evening you look forward to.",
      features: [
        "Gentle warmth for a spa-like glide",
        "Vibration levels you can choose",
        "Metal contact heads on an ABS body",
        "Comb-style accessory included",
        "Rechargeable — use it cordless"
      ],
      howTo: [
        "Start on clean skin with a few drops of the included oil, or your own moisturiser.",
        "Switch on, pick a heat and vibration level, and glide upward and outward along jaw, cheeks and neck.",
        "Massage for 5–10 minutes, then wipe the heads clean and let them dry."
      ],
      included: [
        "Electric Gua Sha Massager",
        "Comb-style accessory",
        "1 or 3 massage oils, depending on the set you choose"
      ],
      specs: [
        ["Type", "Rechargeable massage device"],
        ["Sets", "Device + 1 oil · Device + 3 oils"],
        ["Materials", "ABS housing, metal contact heads, rechargeable electronics"],
        [
          "Oils",
          "Massage oils included for glide. You can also use your own moisturiser."
        ]
      ],
      care:
        "Wipe the contact heads after every use and let them dry before storing. Keep the device away from running water.",
      faq: [
        [
          "What is the difference between the sets?",
          "Both include the same device and comb-style accessory. Device + 3 oils adds two extra massage oils."
        ],
        [
          "Are the oils Valrella formulas?",
          "They are included for glide with the device. You can also use your own moisturiser or facial oil."
        ],
        [
          "How do I charge it?",
          "The device is rechargeable. Charging details are shown with the product images and in the box materials."
        ]
      ]
    },
    "tool-ice-roller": {
      why:
        "The freezer trick, made tidy. Fill the mold, freeze it, and roll cool relief across your face, under-eyes and neck — refillable and reusable, so there's no melting mess to clean up.",
      features: [
        "Refillable and reusable — no single-use ice",
        "Rolls over face, under-eyes and neck",
        "No drips or melting mess",
        "Six colours to choose from"
      ],
      howTo: [
        "Fill the silicone mold with water and freeze until solid.",
        "Twist it onto the handle and roll gently over face, under-eyes and neck.",
        "Keep sessions short, avoid pressing hard, and skip broken or irritated skin.",
        "Rinse the mold after use, then refill and freeze again — or dry fully before storing."
      ],
      included: ["Ice Face Roller (silicone mold + handle)"],
      specs: [
        ["Type", "Refillable ice roller"],
        ["Materials", "Silicone mold and handle (tool — no formula)"],
        ["Colours", "Black, Pink, Purple, Blue, Nude, Green"]
      ],
      care:
        "Rinse the mold after every use. Let it dry fully if you are storing it outside the freezer. Wipe the handle dry before putting it away.",
      faq: [
        [
          "How do I prepare it?",
          "Fill the mold with water, freeze until solid, then twist it onto the handle."
        ],
        [
          "How do I clean it?",
          "Rinse the mold after use. Dry the handle before storing."
        ],
        [
          "Is any formula included?",
          "No — this is a refillable silicone mold and handle only."
        ]
      ]
    },
    "tool-ice-globes": {
      why:
        "Two cold heads you keep in the freezer — or run one under warm water if you want contrast. A little oil, then sweep cheeks and jaw. This is not the cheap ice roller; that is a different tool.",
      features: [
        "Pair of Facial Cryo Sticks",
        "Use cold from the freezer, or one warm",
        "Glide with oil or moisturiser",
        "No charging, no app"
      ],
      howTo: [
        "Keep both in the freezer, or run one under warm — not boiling — water.",
        "Put a little oil or moisturiser on clean skin so the heads glide.",
        "Sweep cheeks, jaw and under-eyes. Keep it short. Skip broken skin.",
        "Wipe the heads dry and put them back in the freezer."
      ],
      included: ["Two Facial Cryo Sticks"],
      specs: [
        ["Type", "Manual cold / contrast sticks"],
        ["In the box", "Two Facial Cryo Sticks"],
        ["Power", "None — freezer or warm water"]
      ],
      care:
        "Wipe the heads after every use. Do not boil them. Dry before they go back in the freezer.",
      faq: [
        [
          "Is this the Ice Face Roller?",
          "No. The Ice Face Roller is the refillable silicone mold. These are two solid heads you chill or warm."
        ],
        [
          "Do they need charging?",
          "No. Freezer, or warm water. That's it."
        ],
        [
          "Is any formula included?",
          "No. Use a few drops of your own oil or moisturiser so they glide."
        ]
      ]
    },
    "tool-scalp-comb": {
      why:
        "The skipped scalp step. Part the hair, switch on, slow pass. This is not the heatless curl set — that one sleeps in.",
      features: [
        "Electric nodes for a slow scalp pass",
        "Use on dry, parted hair",
        "Wipe clean after",
        "Not overnight curls"
      ],
      howTo: [
        "Start on dry hair. Make a part where you want the pass.",
        "Switch on and move slowly along the part. Do not press hard.",
        "Work across a few parts, then switch off.",
        "Wipe the nodes and let them dry."
      ],
      included: ["Electric LED Scalp Massager"],
      specs: [
        ["Type", "Rechargeable scalp massager"],
        ["Use", "Dry, parted hair"],
        ["Not", "Heatless overnight curls — that is a separate product"]
      ],
      care:
        "Wipe the nodes after every use. Keep the body away from running water.",
      faq: [
        [
          "Is this the heatless curl set?",
          "No. Heatless Curls is a different product. This one is a scalp session."
        ],
        [
          "Wet or dry hair?",
          "Dry. Part it first so the nodes reach the scalp."
        ],
        [
          "Is it a medical device?",
          "No. Beauty accessory for an at-home routine. We do not make medical claims."
        ]
      ]
    },
    "kit-glow-tools": {
      why:
        "The starter set. Cleanse with the silicone brush, then the ice roller. Two tools. One short routine. Skip it if you already know the one tool you want.",
      features: [
        "Soft Silicone Face Brush",
        "Ice Face Roller",
        "A first routine without buying the whole shop"
      ],
      howTo: [
        "Wet the silicone brush, cleanse, rinse, pat dry.",
        "Pull the ice roller from the freezer and roll face and under-eyes.",
        "Rinse the mold, refill, freeze again."
      ],
      included: ["Soft Silicone Face Brush", "Ice Face Roller"],
      skipIncludedIfKit: true,
      specs: [
        ["Type", "Starter set"],
        ["Tools", "Silicone face brush and ice roller"],
        ["Not included", "Serums, oils, or extra tools"]
      ],
      care:
        "Rinse the brush and the ice-roller mold after use. Dry the brush fully. Keep the roller handle dry.",
      faq: [
        [
          "What is in the set?",
          "A Soft Silicone Face Brush and an Ice Face Roller."
        ],
        [
          "Is this three tools?",
          "No. Two tools. Brush, then roller."
        ],
        [
          "Can I buy them separately?",
          "The Ice Face Roller is also sold on its own."
        ]
      ]
    },
    "tool-eye-wand": {
      why:
        "A small wand for a short pass around the eyes and high points of the face. Light and a little warmth. Not the full LED mask — that one is hands-free and covers the whole face.",
      features: [
        "Compact wand you hold",
        "Short sessions around eyes and cheeks",
        "Rechargeable",
        "Not a full-face mask"
      ],
      howTo: [
        "Clean dry skin. No product under the wand.",
        "Switch on and glide slowly under the eyes and over cheeks.",
        "Keep it short. Skip broken or irritated skin.",
        "Wipe the head and put it on charge."
      ],
      included: ["Beauty Wand", "Charging cable"],
      specs: [
        ["Type", "Handheld beauty wand"],
        ["Use", "Eyes and high points of the face"],
        ["Charging", "Rechargeable"]
      ],
      care:
        "Wipe the head after every use. Keep the port dry. Do not rinse under the tap.",
      faq: [
        [
          "Is this the LED Face Mask?",
          "No. The mask is hands-free and covers the whole face. This wand is the small one you hold."
        ],
        [
          "How long do I use it?",
          "A short pass. It is a sofa-night tool, not a clinic session."
        ],
        [
          "Is it a medical device?",
          "No. Beauty accessory. We do not make medical claims."
        ]
      ]
    },
    "kit-stone": {
      why:
        "Three classic icons, one slow ritual — and a set that looks considered the moment it's handed over. Sweep with the gua sha, roll with the dual head, then finish with the little ball roller.",
      features: [
        "Three stone tools in one gift-ready set",
        "Gua sha for sweeping along jaw and cheeks",
        "Dual roller for larger areas",
        "Ball roller for the eye area and finishing",
        "Four colours: black, dark green, white, rose quartz"
      ],
      howTo: [
        "Apply a facial oil so the stones glide smoothly.",
        "Sweep the gua sha upward and outward along the jaw and cheeks.",
        "Finish with the rollers, then wipe everything dry."
      ],
      /* Omitted from accordion when the buy-box kit breakdown is already on the page. */
      included: [
        "Gua sha stone",
        "Dual-head roller (smooth + textured)",
        "Ball roller"
      ],
      skipIncludedIfKit: true,
      specs: [
        ["Type", "Manual stone tool set"],
        ["Tools", "Gua sha, dual-head roller, ball roller"],
        ["Materials", "Stone tools with metal fittings (no formula)"],
        ["Colours", "Black, Dark green, White, Rose quartz"]
      ],
      gift:
        "A good gift for gua sha beginners, anyone rebuilding an evening routine, or the person who already owns every serum. These are the classic stone tools, not the electric gua sha.",
      care:
        "Wipe the stones dry after each use and store them somewhere they won't knock together.",
      faq: [
        [
          "What is in the set?",
          "A gua sha stone, a dual-head roller and a ball roller."
        ],
        [
          "Is this the electric gua sha?",
          "No — these are classic manual stone tools. The Electric Gua Sha Massager is a separate product."
        ],
        [
          "What colours are available?",
          "Black, dark green, white and rose quartz."
        ]
      ]
    }
  };

  var SHARED_FAQ = [
    ["How much is shipping?", SHIPPING],
    ["What is your returns policy?", RETURNS],
    ["How can I contact Valrella?", CONTACT]
  ];

  function onPdp() {
    return location.pathname.indexOf("/products/") !== -1;
  }

  function handle() {
    var parts = location.pathname.split("/");
    var i = parts.indexOf("products");
    return i >= 0 ? parts[i + 1] || "" : "";
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function list(items, cls) {
    var ul = el("ul", cls);
    items.forEach(function (item) {
      ul.appendChild(el("li", null, item));
    });
    return ul;
  }

  function panel(title, node, open) {
    var d = el("details", "lm-pdp__panel");
    if (open) d.open = true;
    var s = el("summary", "lm-pdp__summary");
    s.appendChild(el("span", null, title));
    s.appendChild(el("span", "lm-faq__mark"));
    d.appendChild(s);
    var body = el("div", "lm-pdp__panel-body");
    body.appendChild(node);
    d.appendChild(body);
    return d;
  }

  function para(text) {
    return el("p", null, text);
  }

  function faqBlock(items) {
    var wrap = el("div", "lm-pdp__faq");
    items.forEach(function (pair) {
      var item = el("details", "lm-pdp__faq-item");
      var s = el("summary", "lm-pdp__faq-q");
      s.appendChild(el("span", null, pair[0]));
      s.appendChild(el("span", "lm-faq__mark"));
      item.appendChild(s);
      var a = el("div", "lm-pdp__faq-a");
      a.appendChild(para(pair[1]));
      item.appendChild(a);
      wrap.appendChild(item);
    });
    return wrap;
  }

  function build() {
    var id = handle();
    var data = CONTENT[id] || {
      why:
        "A Valrella at-home beauty tool — simple to add to the routine you already have."
    };
    var host = document.querySelector(
      ".product-information, [data-testid='product-information']"
    );
    if (!host || document.querySelector(".lm-pdp")) return;
    var mount = host.closest(".shopify-section") || host;

    var sec = el("section", "lm-pdp");
    sec.setAttribute("aria-labelledby", "lm-pdp-title");
    var inner = el("div", "lm-pdp__inner");

    var lead = el("div", "lm-pdp__lead");
    lead.appendChild(el("p", "lm-eyebrow", "Product details"));
    var h2 = el("h2", "lm-sec__title", data.why ? "Why you'll love it" : "Good to know");
    h2.id = "lm-pdp-title";
    lead.appendChild(h2);
    if (data.why) lead.appendChild(el("p", "lm-pdp__why", data.why));
    if (data.gift) lead.appendChild(el("p", "lm-pdp__why", data.gift));
    if (data.features) {
      lead.appendChild(el("h3", "lm-pdp__subtitle", "Key features"));
      lead.appendChild(list(data.features, "lm-pdp__features"));
    }
    inner.appendChild(lead);

    var panels = el("div", "lm-pdp__panels");
    if (data.howTo && !document.querySelector(".lumen-howto")) {
      var ol = el("ol", "lm-pdp__steps");
      data.howTo.forEach(function (step) {
        ol.appendChild(el("li", null, step));
      });
      panels.appendChild(panel("How to use", ol, true));
    }

    var showIncluded =
      data.included &&
      !(data.skipIncludedIfKit && document.querySelector(".lumen-kit"));
    if (showIncluded) {
      panels.appendChild(
        panel("What's included", list(data.included, "lm-pdp__plain"), !data.howTo)
      );
    }

    if (data.specs) {
      var dl = el("dl", "lm-pdp__specs");
      data.specs.forEach(function (row) {
        dl.appendChild(el("dt", null, row[0]));
        dl.appendChild(el("dd", null, row[1]));
      });
      panels.appendChild(panel("Specifications", dl));
    }

    var shipWrap = el("div");
    shipWrap.appendChild(para(SHIPPING));
    shipWrap.appendChild(para(PACKAGING));
    panels.appendChild(panel("Shipping and packaging", shipWrap));

    var retWrap = el("div");
    retWrap.appendChild(para(RETURNS));
    var link = el("a", "lm-textlink", "Read the refund policy");
    link.href = "/policies/refund-policy";
    retWrap.appendChild(link);
    panels.appendChild(panel("Returns", retWrap));

    var careWrap = el("div");
    if (data.care) careWrap.appendChild(para(data.care));
    careWrap.appendChild(para(NOT_MEDICAL));
    panels.appendChild(panel("Care and safety", careWrap));

    var faqItems = (data.faq || []).concat(SHARED_FAQ);
    panels.appendChild(panel("FAQ", faqBlock(faqItems)));

    var contactP = el("p", "lm-pdp__contact");
    contactP.appendChild(document.createTextNode("Still need help? "));
    var contactA = el("a", "lm-textlink", "valrellasupport@gmail.com");
    contactA.href = "mailto:valrellasupport@gmail.com";
    contactP.appendChild(contactA);
    panels.appendChild(contactP);

    inner.appendChild(panels);
    sec.appendChild(inner);
    mount.insertAdjacentElement("afterend", sec);
  }

  function boot() {
    if (!onPdp()) return;
    build();
    setTimeout(build, 600);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
